import m from "../../geodata/es2015/eswatiniLow";
window.am4geodata_eswatiniLow = m;


//////////////////
// WEBPACK FOOTER
// ./geodata/eswatiniLow.js
// module id = null
// module chunks = 